import { SyncCoreDataDefinitionsEnumTranslator, IDataDefinitionsEnums } from '@edgebox/sync-core-data-definitions';
import React from 'react';

interface IProps<Enum extends string> {
  enumName: keyof IDataDefinitionsEnums;
  keyName?: Enum;
}

export class SyncCoreDataDefinitionsEnumValue<Enum extends string> extends React.Component<IProps<Enum>, {}> {
  render(): React.ReactElement {
    const { enumName, keyName } = this.props;

    return <>{keyName ? SyncCoreDataDefinitionsEnumTranslator.transLateEnumValue(enumName, keyName) : 'unknown'}</>;
  }
}
